import './Utilities.scss'

import * as lottie_arrives from '../../lotties/Utilities/arrive.json'
import * as lottie_contacts from '../../lotties/Utilities/contacts.json'

import Bike from '../../components/Icons/Bike'
import ContactCard from '../../components/ContactCard/ContactCard'
import Desplegable from '../../components/Desplegable/Desplegable'
import DidYouKnow from '../../components/DidYouKnow/DidYouKnow'
import KiteIcon from '../../components/KiteIcon/KiteIcon'
import ListItem from '../../components/ListItem/ListItem'
import Lottie from 'react-lottie'
import MapsBanner from '../../components/MapsBanner/MapsBanner'
import { ModalContainer } from '../../components/Containers/ModalContainer'
import Plug from '../../components/Icons/Plug'
import { SectionContainer } from '../../components/Containers/SectionContainer'
import { animated } from 'react-spring'
import { contacts } from '../../data'

const Utilities = ({ color = 'blue', secondary = 'yellow', scrollRight, modalHandling, closeModal, section, parallax, setLock }) => {
  // Lotties

  // https://assets7.lottiefiles.com/private_files/lf30_Pc7YxP.json
  const lottieContacts = (
    <Lottie
      options={{
        loop: true,
        autoplay: true,
        animationData: lottie_contacts.default,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
      }}
      width={150}
      height={150}
      speed={0.5}
    />
  )

  // https://assets2.lottiefiles.com/packages/lf20_aSLIN9.json
  const lottieArrives = (
    <Lottie
      options={{
        loop: true,
        autoplay: true,
        animationData: lottie_arrives.default,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
      }}
      width={150}
      height={150}
      speed={0.5}
    />
  )

  // Desplegables area
  const cantoblanco = (
    <div className="desplegable-container cantoblanco">
      <MapsBanner color={color} secondary={secondary} address="https://goo.gl/maps/cK7yBWd9Vkmmr1LW6" text="Abrir en Google Maps" />

      <div className="block">
        <KiteIcon color={secondary} icon="car" />
        <p>Ctra. M-607 (MadridColmenar), km. 15,5. 28049, Madrid</p>
      </div>
      <div className="block">
        <KiteIcon color={secondary} icon="bus" />
        <p className="dotted text-normal">
          <span className="colored bold blue">Línea 714: </span>Plaza de Castilla – UAM Cantoblanco
        </p>
        <p className="dotted text-normal">
          <span className="colored bold blue">Línea 827: </span>Madrid (Canillejas)- Aeropuerto T4 – Alcobendas – UAM Cantoblanco – Tres Cantos{' '}
        </p>
        <p className="dotted text-normal">
          <span className="colored bold blue">Línea 827A: </span>San Sebastián de los Reyes – Alcobendas – UAM Cantoblanco
        </p>
        <p className="dotted text-normal">
          <span className="colored bold blue">Línea 828: </span>Madrid (Canillejas) – Alcobendas – UAM Cantoblanco
        </p>
      </div>
      <div className="block">
        <KiteIcon icon="renfe" color={secondary} />
        <p>Los trenes de Cercanías conectan las estaciones más importantes con el Campus</p>
        <p className="text-normal dotted">
          <span className="colored bold blue">Línea C-4a: </span>Parla - Atocha - Alcobendas/San Sebastián de los Reyes
        </p>
        <p className="text-normal dotted">
          <span className="colored bold blue">Línea C-4b: </span>Parla - Atocha - Colmenar
        </p>
      </div>
    </div>
  )

  const medina = (
    <div className="desplegable-container medina">
      <MapsBanner color={color} secondary={secondary} address="https://goo.gl/maps/z6yUaCVuXy3x3oPg8" text="Abrir en Google Maps" />
      <div className="block">
        <KiteIcon color={secondary} icon="car" />
        <p>Ctra. M-607 (MadridColmenar), km. 15,5. 28049, Madrid</p>
      </div>
      <div className="block">
        <KiteIcon color={secondary} icon="bus" />
        <p className="dotted text-normal">
          <span className="colored bold blue">Línea 67: </span>Plaza de Castilla - Barrio de Peñagrande
        </p>
        <p className="dotted text-normal">
          <span className="colored bold blue">Línea 124: </span>Cuatro Caminos - Lacoma
        </p>
        <p className="dotted text-normal">
          <span className="colored bold blue">Línea 132: </span>Moncloa - Hospital La Paz
        </p>
        <p className="dotted text-normal">
          <span className="colored bold blue">Línea 135: </span>Plaza de Castilla - Hospital Ramón y Cajal
        </p>
        <p className="dotted text-normal">
          <span className="colored bold blue">Línea 137: </span>Puerta de Hierro (Madrid) - Fuencarral
        </p>
        <p className="dotted text-normal">
          <span className="colored bold blue">Línea 714: </span>UAM Cantoblanco - Plaza de Castilla
        </p>
      </div>
      <div className="block">
        <KiteIcon icon="metro" color={secondary} />
        <p className="text-normal dotted">
          <span className="colored bold blue">Línea 10: </span>Begoña
        </p>
      </div>
    </div>
  )

  const autonoBus = (
    <div className="desplegable-container autonobus">
      <ListItem color={secondary} custom={<Plug color={secondary} />}>
        <p>
          Un vehículo <span className="bold">eléctrico sin conductor</span> que circula por el campus realizando varias paradas. Este autobús está especialmente
          adaptado para que puedan <span className="bold">utilizarlo personas con movilidad reducida.</span>
        </p>
      </ListItem>
    </div>
  )

  const theBike = (
    <div className="desplegable-container the-bike">
      <ListItem color={secondary} custom={<Bike color={secondary} />}>
        <p>
          La bici es un medio de transporte muy común en el campus, donde encontrarás muchos <b>aparcabicis</b>, y es una de las maneras más{' '}
          <b>sostenibles y cómodas</b> de trasladarse en este entorno.
        </p>
      </ListItem>
    </div>
  )

  // Modals area
  const contactsModal = (
    <ModalContainer secondary={secondary} color={color} title="Listín de contacto" onClick={() => closeModal()}>
      {lottieContacts}
      {contacts && Object.values(contacts).map((c) => <ContactCard key={c.id} data={c} />)}
    </ModalContainer>
  )

  const arrive = (
    <ModalContainer secondary={secondary} color={color} title="Cómo llegar a la UAM" onClick={() => closeModal()}>
      {lottieArrives}
      <div className="questions-container-list">
        <Desplegable secondary={secondary} color={color} title="A Cantoblanco">
          {cantoblanco}
        </Desplegable>
        <Desplegable secondary={secondary} color={color} title="A Medicina">
          {medina}
        </Desplegable>
        <DidYouKnow color={color}>
          <p>
            El <b>acceso en coche</b> es el principal responsable de la huella de carbono de la UAM. <b>Prioriza el transporte público</b> o los modos no
            motorizados. En la UAM existen <b>puntos de recarga de coches, bicicletas y patinetes</b>.
          </p>
        </DidYouKnow>
      </div>
    </ModalContainer>
  )

  const movement = (
    <ModalContainer secondary={secondary} color={color} title="Desplazamiento en el Campus" onClick={() => closeModal()}>
      <p>
        Una de las mayores ventajas de los campus UAM es que <span className="bold">¡todo está cerca!</span> En Cantoblanco, el más grande, no tardarás mucho
        más de 10 minutos en ir de una punta a otra. Si prefieres agilizar los trayectos, existen dos <span className="bold">medios de comunicación</span>{' '}
        totalmente <span className="bold">ecológicos</span> que puedes utilizar.
      </p>
      <div className="questions-container-list">
        <Desplegable secondary={secondary} color={color} title="El autobús autónomo">
          {autonoBus}
        </Desplegable>
        <Desplegable secondary={secondary} color={color} title="La Bici">
          {theBike}
        </Desplegable>
      </div>
    </ModalContainer>
  )

  const items = [
    { key: 'contacts', content: contactsModal, title: 'Listín de contacto' },
    { key: 'arrive', content: arrive, title: 'Cómo llegar a la UAM' },
    { key: 'movement', content: movement, title: 'Desplazamiento en el campus' }
  ]

  const Splash = (
    <>
      <div className="logo-back">
        <img src="/splash/svg/Utilities_logo_back.svg" alt="" />
      </div>
      <animated.div className="logo-main" style={{ transform: parallax.logo_main(section) }}>
        <img src="/splash/svg/Utilities_logo_main.svg" className="illustration" alt="" />
        <img src="/splash/png/Utilities.png" className="image" alt="" />
      </animated.div>
      <div className="logo-front">
        <img src="/splash/svg/Utilities_logo_front.svg" alt="" />
      </div>
    </>
  )

  return (
    <SectionContainer
      // Section
      className={'Utilities'}
      title={'Utilidades'}
      // General
      color={color}
      secondary={secondary}
      items={items}
      setLock={setLock}
      section={section}
      // Mobile
      handleMobileModal={modalHandling}
      scrollRight={scrollRight}
    >
      {Splash}
    </SectionContainer>
  )
}

export default Utilities
